import React from 'react';
import GlobalToaster from './src/components/GlobalToaster';
import "bootstrap/dist/css/bootstrap.min.css";
import './src/styles/customToaster.css';
import './src/styles/pageVariables.css';
import "./src/styles/layout.css";
import './src/styles/global.css';
import './src/styles/global-responsive.css';
import './src/styles/globalHeader.css';
import './src/styles/globalFooter.css';

export const onInitialClientRender = () => {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 84) {
      document.getElementById("headerMenu")?.classList.add("globalStickyHeader");
      document.getElementById("mainBody")?.classList.add("stickyHeaderBody");
    } else {
      document.getElementById("headerMenu")?.classList.remove("globalStickyHeader");
      document.getElementById("mainBody")?.classList.remove("stickyHeaderBody");
    }
  });
};

export function wrapPageElement({ element }) {
  return (
    <>
      <div>{element}</div>
      <GlobalToaster />
    </>
  );
}

